import {
  Accordion,
  Button,
  Divider,
  Grid,
  Paper,
  Typography,
  styled,
} from '@mui/material';
import type { DefaultTheme } from '@mui/styles/defaultTheme';
import Color from 'color';

export const StyledTypography = styled(Typography)(({ theme }) => {
  return {
    fontSize: '1.65rem',
    color: theme.palette.text.contrastText,
  };
});

export const SummaryCard = styled(Paper)(({ theme }) => {
  return {
    padding: '1.75rem',
    width: '100%',
    marginTop: '1rem',
    border:
      theme.palette.mode === 'light'
        ? 'none'
        : `1.75px solid ${theme.palette.divider}`,
  };
});

export const StyledAccordion = styled(Accordion)(({ theme }) => {
  return {
    borderRadius: '8px',
    padding: '0.75rem',
    margin: '1.25rem 0',
    border:
      theme.palette.mode === 'light'
        ? 'none'
        : `1.75px solid ${theme.palette.divider}`,
  };
});

export const RightAlignedGrid = styled(Grid)(({ theme }) => {
  return {
    textAlign: 'right',
  };
});

export const StyledDivider = styled(Divider)(({ theme }) => {
  return {
    margin: '0.45rem 0',
    opacity: theme.palette.mode === 'light' ? 0.25 : 0.75,
  };
});

/* Grids */
const _getBaseGridStyles = (theme: DefaultTheme) => {
  return {
    padding: '1rem 3rem',
    fontSize: '1.25rem',

    color: theme.palette.text.contrastText,
  };
};

export const StyledGridContainer = styled(Grid)(({ theme }) => {
  return {
    background:
      theme.palette.mode === 'light'
        ? theme.palette.background.paleBlue
        : Color(theme.config.colors.charcoal).lighten(0.2).toString(),
    marginTop: '1rem',
    ..._getBaseGridStyles(theme),
  };
});

export const PaleStyledGridContainer = styled(Grid)(({ theme }) => {
  return {
    background:
      theme.palette.mode === 'light'
        ? Color(theme.palette.background.paleBlue).lighten(0.055).string()
        : Color(theme.config.colors.charcoal).lighten(0.55).string(),
    marginTop: '0.5rem',
    ..._getBaseGridStyles(theme),
  };
});

/* Grids */

export const StyledButton = styled(Button)(({ theme, variant }) => {
  return {
    background:
      variant === 'outlined' ? 'transparent' : theme.palette.common.cowbellBlue,

    border: `1px solid ${theme.palette.common.cowbellBlue}`,
    textTransform: 'capitalize',
    letterSpacing: 1.25,

    color: variant === 'outlined' ? theme.palette.common.cowbellBlue : 'white',
    padding: '0.5rem 1rem',
    minWidth: '14rem',
    fontWeight: 600,
    '&:hover, &:focus': {
      background:
        variant === 'outlined'
          ? theme.palette.common.cowbellBlue
          : Color(theme.palette.common.cowbellBlue).darken(0.1).toString(),

      color: theme.config.colors.white,
    },
  };
});
